import { Injectable } from '@angular/core';
import { Facility } from '../types/facility';
import { MeasurementSystem } from '../types/measurement-system';
import { UserPreferences } from '../types/user-preferences';
import { FacilityStore } from './facility.store';

@Injectable({
  providedIn: 'root',
})
export class MeasurementSystemStore {
  private measurementSystem: MeasurementSystem = MeasurementSystem.US_CUSTOMARY;

  constructor(private facilityStore: FacilityStore) {}

  updateMeasurementSystem(userPreferences?: UserPreferences) {
    const facility: Facility | null = this.facilityStore.getCurrentFacility();

    this.measurementSystem =
      userPreferences?.measurementSystem || facility?.measurementSystem || MeasurementSystem.US_CUSTOMARY;
  }

  getMeasurementSystem(): MeasurementSystem {
    return this.measurementSystem;
  }
}
